import { Row } from "antd";
import { comemosTodos } from "./assets/images";

const Closed = () => {
  return (
    // <div className="closed">
    // <h1>Sorry, we are closed</h1>
    // </div>
    <Row justify={"center"}>
      <img
        src={comemosTodos}
        style={{
          maxWidth: "100%",
        }}
        alt="Comemos Tod@s"
      />
      <h3>
        {/* El periodo de inscripción ha concluido, te invitamos a estar pendiente de la publicación de resultados en las redes sociales de la Secretaría de Bienestar de Quintana Roo y en <a href="https://qroo.gob.mx/sedeso/mujeresvida/">qroo.gob.mx/sedeso/mujeresvida/</a>. */}
        El plazo para participar en esta convocatoria para NUEVOS REGISTROS EN
        COMEMOS TOD@S 2026 ha expirado. Agradecemos tu interés.
      </h3>
    </Row>
  );
};

export default Closed;
